export function TableLoading() {
  return (
    <div className="absolute inset-0 bg-white/50 dark:bg-gray-900/50 flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 dark:border-indigo-400" />
    </div>
  );
}
